module.exports = __webpack_public_path__ + "img/block_3.8dd84008.webp";